import React, { useState } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import {
  Button,
  Paper,
  TextField,
  Grid,
  Slider,
  withStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useEffect } from "react";
import { useRef } from "react";
import Loader from "../../Components/loader";
import { useHistory } from "react-router";
import {
  getAllPackage,
  getPackageByName,
  getPinCode,
} from "../../actions/GenomicsAdminAction";
// import { getPackageBySlug, getAllPackage, getPackageByName, getPinCode, } from '../../actions/gnadminActions'
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
// import PinCode from "../PinCode";

const StyledTableCell:any = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: "#925A91",
      color: theme.palette.common.white,
      fontSize: "15px",
    },
    body: {
      fontSize: 15,
    },
  })
)(TableCell);
const StyledTableRow:any = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
)(TableRow);
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 0,
    },
    toolbar: {
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
    },
    content: {
      width: "60%",
      flexGrow: 21,
    },
    contentHeader: {
      width: "100%",
      padding: "0px 10px 50px 10px",
      minHeight: "65px",
    },
    leftContentHeader: {
      width: "50%",
      float: "left",
    },
    rightContentHeader: {
      width: "50%",
      float: "right",
      textAlign: "right",
      paddingRight: "20px",
    },
    paper: {
      padding: "1rem",
      width: "100%",
      borderRadius: "10px",
    },
    head: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "1rem",
      textAlign: "center",
    },
    heading: {
      fontWeight: "normal",
      fontSize: "1.2rem",
      margin: "0",
    },
    table: {
      maxHeight: "500px",
      margin: "auto",
      overflow: "auto",
    },
    image: {
      width: "100px",
      height: "auto",
    },
    imageSM: {
      width: "50px",
      height: "auto",
    },
    imgContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexWrap: "wrap",
    },
    tableContainer: {
      marginTop: "2rem",
      position: "sticky",
      top: "200px",
    },
  })
);

const PrettoSlider = withStyles({
  root: {
    color: "rgb(156, 75, 155)",
    height: 7,
  },
  thumb: {
    height: 25,
    width: 26,
    backgroundColor: "violet",
    border: "2px solid purple",
    marginTop: -7,
    marginLeft: -12,
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
  active: {},
  valueLabel: {
    left: "calc(-50% + 5px)",
  },
  track: {
    height: 7,
    borderRadius: 5,
  },
  rail: {
    height: 7,
    borderRadius: 5,
  },
})(Slider);

interface Props {
  createPackage: any;
  cityPriceList: any;
  getCityPrice: any;
  allPackageList: any;
  getBlogTags: any;
  blogTags: any;
  loading: any;
  Item: any;
  pin_code: any;
  getAllPackage: any;
  getPackageByName: any;
  packageByName: any;
  getPinCode: any;
}

const CreatePackagePage: React.FC<Props> = ({
  createPackage,
  cityPriceList,
  getCityPrice,
  allPackageList,
  getAllPackage,
  getBlogTags,
  blogTags,
  loading,
  pin_code,
  getPinCode,
  getPackageByName,
  packageByName,
}) => {
  const classes = useStyles();
  const [pincode, setPinCode] = useState<String>("");
  const [cityId, setCityId] = useState<any>("");
  const [testCategory, settestCategory] = useState<string>("any");
  const [homecollection, sethomecollection] = useState<string>("any");
  const [Speciality, setSpeciality] = useState<string>("any");
  const [disease, setdisease] = useState<string>("any");

  const [searchtext, setsearchtext] = useState<any>("");
  const history = useHistory();
  const [packageName, setPackageName] = useState<any>("");
  const [selectedPackageName, setSelectedPackagename] = useState<any>("");
  const [fullPageView, setFullPageView] = useState<any>(0);
  const timer = useRef<any>(0);

  useEffect(() => {
    getAllPackage();
    getPinCode();
  }, []);
  const handleSearchPackage = () => {
    setSelectedPackagename(packageName);
    getPackageByName(`${packageName}/?city_id=${cityId}`);
  };
  const handleView = () => {
    setFullPageView(1);
  };
  const handleRemoveView = () => {
    setFullPageView(0);
  };
  const handlePinCode = (val: String) => {
    setPinCode(val as string);
    const { cityid } = pin_code.results.find(
      (code: any) => code.pincode === val
    );
    setCityId(cityid);
  };

  return (
    <>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <div className={classes.contentHeader}>
          <div className={classes.leftContentHeader}>
            <h4 style={{ fontWeight: "bold" }}>PACKAGE DETAILS</h4>
          </div>
          <div className={classes.rightContentHeader}></div>
        </div>
        <Paper elevation={5} className={classes.paper}>
          <Grid container spacing={3} style={{ margin: "15px auto" }}>
            <Grid item xs={12} md={3}>
              <Autocomplete
                id="pincode"
                onChange={(event, newValue) => {
                  if (newValue) {
                    let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                    handlePinCode(obj.pincode as String);
                  }
                }}
                options={pin_code.results || []}
                freeSolo
                blurOnSelect
                aria-required
                getOptionLabel={(option: any) =>
                  `${option.pincode}, ${option.area}`
                }
                onInputChange={(event, newInputValue) => {
                  clearTimeout(timer.current);
                  timer.current = setTimeout(() => {
                    getPinCode(newInputValue.split(",")[0]);
                  }, 1000);
                }}
                renderInput={(params) => (
                  <TextField
                    className="input"
                    {...params}
                    label="Pin Code"
                    variant="outlined"
                    fullWidth
                    required
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <Autocomplete
                id="test_name"
                onChange={(event, newValue) => {
                  if (newValue) {
                    let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                    setPackageName(obj.slug);
                  }
                }}
                options={allPackageList.results || []}
                freeSolo
                blurOnSelect
                aria-required
                getOptionLabel={(option: any) =>
                  option.name + "(" + option.code + ")"
                }
                onInputChange={(event, newInputValue) => {
                  clearTimeout(timer.current);
                  timer.current = setTimeout(() => {
                    getAllPackage(`city_id=${cityId}&name_or_code=${newInputValue}`);
                    // getAllPackage(`name_or_code=${newInputValue}`)
                  }, 200);
                  if (newInputValue.length === 0) {
                    setPackageName(0);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    className="input"
                    {...params}
                    label="Search Test Name"
                    variant="outlined"
                    fullWidth
                    required
                  />
                )}
                disabled={pincode === ""}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => handleSearchPackage()}
                disabled={packageName === ""}
                fullWidth
                style={{ marginTop: 15, height: "50px" }}
              >
                Search
              </Button>
            </Grid>
            <Grid item xs={12} md={2}>
              {" "}
              <Button
                variant="contained"
                color="secondary"
                style={{ marginTop: 15, height: "50px" }}
                fullWidth
                onClick={() => history.push("/dashboard/gnadmin/view_package")}
              >
                Reset
              </Button>
            </Grid>
          </Grid>
        </Paper>

        {selectedPackageName !== "" ? (
          <TableContainer
            className={classes.tableContainer}
            component={Paper}
            style={{ maxHeight: "540px" }}
          >
            {loading ? (
              <Loader />
            ) : (
              <Table stickyHeader aria-label="simple table">
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell align="center">Action</StyledTableCell>
                    <StyledTableCell align="center">Test Code</StyledTableCell>
                    <StyledTableCell align="center">Test Name</StyledTableCell>
                    <StyledTableCell align="center">
                      Sample Type
                    </StyledTableCell>
                    <StyledTableCell align="center">MRP</StyledTableCell>
                    <StyledTableCell align="center">Schedule </StyledTableCell>
                    <StyledTableCell align="center">TaT Time</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  <StyledTableRow>
                    <StyledTableCell align="center">
                      {fullPageView === 0 ? (
                        <AddCircleOutlineIcon onClick={() => handleView()} />
                      ) : (
                        <RemoveCircleOutlineIcon
                          onClick={() => handleRemoveView()}
                        />
                      )}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {packageByName && packageByName?.code}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {packageByName && packageByName?.slug}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {packageByName && packageByName?.description}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {packageByName && packageByName?.package_price}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {packageByName && packageByName?.parameter}
                    </StyledTableCell>
                    {/* <StyledTableCell align="center">{packageByName && packageByName?.parameter}</StyledTableCell> */}
                    <StyledTableCell align="center">
                      {packageByName && packageByName?.tat_time}
                    </StyledTableCell>
                  </StyledTableRow>
                </TableBody>
              </Table>
            )}
            {fullPageView === 1 ? (
              <Paper elevation={5} className={classes.paper}>
                <div
                  className={classes.root}
                  style={{ backgroundColor: "#925A91", padding: "12px" }}
                >
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Paper className={classes.paper}>
                        <Grid container spacing={2}>
                          <Grid item xs={5}>
                            <Paper className={classes.paper}>TEST CODE</Paper>
                            {/* <Paper className={classes.paper}>{packageByName && packageByName?.code + " " + packageByName?.slug}</Paper> */}
                          </Grid>
                          <Grid item xs={7}>
                            <Paper className={classes.paper}>
                              {packageByName && packageByName?.code}
                            </Paper>
                          </Grid>
                          <Grid item xs={5}>
                            <Paper className={classes.paper}>TEST NAME</Paper>
                            {/* <Paper className={classes.paper}>{packageByName && packageByName?.code + " " + packageByName?.slug}</Paper> */}
                          </Grid>
                          <Grid item xs={7}>
                            <Paper className={classes.paper}>
                              {packageByName && packageByName?.name}
                            </Paper>
                          </Grid>
                          <Grid item xs={5}>
                            <Paper className={classes.paper}>
                              COMPONENTS & DEPARTMENT
                            </Paper>
                          </Grid>
                          <Grid item xs={7}>
                            <Paper className={classes.paper}>
                              {packageByName &&
                                packageByName?.specimen_instructions}
                            </Paper>
                          </Grid>
                          <Grid container spacing={1}>
                            <Grid item xs={5}>
                              <Paper className={classes.paper}>STABILITY</Paper>
                            </Grid>
                            <Grid item xs={7}>
                              <Grid container spacing={2}>
                                <Grid item xs={5}>
                                  <Paper className={classes.paper}>Room</Paper>
                                </Grid>
                                <Grid item xs={5}>
                                  <Paper className={classes.paper}>
                                    Refrigerated
                                  </Paper>
                                </Grid>
                                <Grid item xs={5}>
                                  <Paper className={classes.paper}>
                                    Frozen
                                  </Paper>
                                </Grid>
                                <Grid item xs={5}>
                                  <Paper className={classes.paper}>
                                    25 hrs
                                  </Paper>
                                </Grid>
                                <Grid item xs={5}>
                                  <Paper className={classes.paper}>
                                    7 days
                                  </Paper>
                                </Grid>
                                <Grid item xs={5}>
                                  <Paper className={classes.paper}>
                                    60 days
                                  </Paper>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item xs={5}>
                            <Paper className={classes.paper}>QUANTITY</Paper>
                          </Grid>
                          <Grid item xs={7}>
                            <Paper className={classes.paper}>1</Paper>
                          </Grid>

                          <Grid item xs={5}>
                            <Paper className={classes.paper}>METHOD</Paper>
                          </Grid>
                          <Grid item xs={7}>
                            <Paper className={classes.paper}>CLIA</Paper>
                          </Grid>
                          <Grid item xs={5}>
                            <Paper className={classes.paper}>SCHEDULE</Paper>
                          </Grid>
                          <Grid item xs={7}>
                            <Paper className={classes.paper}>
                              {packageByName &&
                                packageByName?.tat_time_duration}
                            </Paper>
                          </Grid>
                          <Grid item xs={5}>
                            <Paper className={classes.paper}>TAT</Paper>
                          </Grid>
                          <Grid item xs={7}>
                            <Paper className={classes.paper}>
                              {packageByName && packageByName?.tat_time}
                            </Paper>
                          </Grid>
                          <Grid item xs={5}>
                            <Paper className={classes.paper}>DISEASE</Paper>
                          </Grid>
                          <Grid item xs={7}>
                            <Paper className={classes.paper}>
                              Disorders of Thyroid gland
                            </Paper>
                          </Grid>
                          <Grid item xs={5}>
                            <Paper className={classes.paper}>USAGE</Paper>
                          </Grid>
                          <Grid item xs={7}>
                            <Paper className={classes.paper}>
                              As per Newborn Screening guidelines for..{" "}
                            </Paper>
                          </Grid>
                          <Grid item xs={5}>
                            <Paper className={classes.paper}>
                              Dr SPECIALITY
                            </Paper>
                          </Grid>
                          <Grid item xs={7}>
                            <Paper className={classes.paper}>
                              Pediatrician
                            </Paper>
                          </Grid>

                          <Grid item xs={5}>
                            <Paper className={classes.paper}>AGE GROUP</Paper>
                          </Grid>
                          <Grid item xs={7}>
                            <Paper className={classes.paper}>
                              {packageByName && packageByName?.recommended_age}
                            </Paper>
                          </Grid>
                          <Grid item xs={5}>
                            <Paper className={classes.paper}>
                              TEST INFORMATION
                            </Paper>
                          </Grid>
                          <Grid item xs={7}>
                            <Paper className={classes.paper}>
                              {packageByName && packageByName?.fasting_time}
                            </Paper>
                          </Grid>
                          <Grid item xs={5}>
                            <Paper className={classes.paper}>
                              TEST CATEGORY
                            </Paper>
                          </Grid>
                          <Grid item xs={7}>
                            <Paper className={classes.paper}>
                              {packageByName && packageByName?.test_category}
                            </Paper>
                          </Grid>
                          <Grid item xs={5}>
                            <Paper className={classes.paper}>
                              PACKAGE TYPE
                            </Paper>
                          </Grid>
                          <Grid item xs={7}>
                            <Paper className={classes.paper}>
                              {packageByName && packageByName?.type}
                            </Paper>
                          </Grid>
                        </Grid>
                      </Paper>
                    </Grid>
                  </Grid>
                </div>
              </Paper>
            ) : (
              ""
            )}
          </TableContainer>
        ) : (
          ""
        )}
      </main>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  allPackageList: state.GenomicsAdminReducer.allPackageList,
  packageByName: state.GenomicsAdminReducer.packageByName,
  pin_code: state.GenomicsAdminReducer.pin_code,
});

export default connect(mapStateToProps, {
  getAllPackage,
  getPackageByName,
  getPinCode,
})(CreatePackagePage);
